module.exports = __webpack_public_path__ + "img/add.81090f12.svg";